import { Component } from '@angular/core';
import { ProductEditorComponent } from '../product-editor/product-editor.component';
import { Product } from '../../types/Product';
import { Observable } from 'rxjs';
import { ProductService } from '../../services/products.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingComponent, ToastService } from '@digi-america/shared';
import { AsyncPipe, NgIf } from '@angular/common';

@Component({
  selector: 'app-update-product',
  imports: [ProductEditorComponent, LoadingComponent, NgIf, AsyncPipe],
  template: `<ng-template #loading>
    <app-loading></app-loading>
  </ng-template>
  <span *ngIf="product$ | async as product; else loading">
    <app-product-editor [new]="false" [product]="product" (productSaved)="updateProduct($event)"></app-product-editor>
  </span>`
})
export class UpdateProductComponent {
  product$!: Observable<Product>;

  constructor(private productService: ProductService, private route: ActivatedRoute, private router: Router, private toastService: ToastService) { }

  ngOnInit(): void {
    this.route.params.subscribe({
      next: (params) => {
        this.product$ = this.productService.getProduct(params['id']);
      }
    })
  }

  updateProduct(product: Product) {
    this.productService.updateProduct(product.id, product).subscribe({
      next: () => {
        this.router.navigate(["product-search", product.type]);
        this.toastService.success("Product Updated!");
      },
      error: (problem) => {
        this.toastService.error(JSON.stringify(problem.error || problem.errors));
      }
    });
  }
}
